import { Router, NavigationEnd } from '@angular/router';
import { Component, Output, EventEmitter } from '@angular/core';

import { EditionService } from '../shared/services/edition.service';
import { PermissionsService } from '../shared/services/permissions.service';
import { AllPermissions } from '../models/permissions';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.less']
})

export class NavigationComponent {
  public inProgram: boolean;
  public programId: number;
  public displayGlobal = true;
  public permissions: AllPermissions;

  @Output() clearSearch: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private editionService: EditionService,
    public permissionsService: PermissionsService,
  ) {
    this.router.events.filter(e => e instanceof NavigationEnd).subscribe((e: NavigationEnd) => {
      let current = e.url.toString().split('/');
      if (current.indexOf('programs') !== -1) {
        this.inProgram = true;
        this.programId = parseInt(current[3], 10);
      } else {
        this.inProgram = false;
      }
    });
    permissionsService.retrievePermissions().subscribe(permissions => {
      this.permissions = permissions;
    });
   }

   public emitClearSearch(): void {
     this.clearSearch.emit(true);
   }

   public gotoKnowledgeCenter(): boolean {
    this.editionService.jumpToLearning("/auth/knowledge-center");
    return false;
   }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/navigation/navigation.component.ts